import { Extract } from './extract';

export class Field {
  constructor(
    public autoLoad?: boolean,
    public bindingSet?: any,
    public controlType?: number,
    public dbType?: string,
    public description?: string,
    public editableGrid?: any,
    public extract?: Extract,
    public format?: any,
    public maxValue?: any,
    public minValue?: any,
    public name?: string,
    public options?: any,
    public readOnly?: boolean,
    public required?: boolean,
    public size?: any,
    public title?: string,
    public watermark?: string,
    public value?: string,
    public label?: string,
  ) { }
}
